/**
 * 员工
 */
import fetch from '../utils/fetch'

// 获取二维码
const getDetail = params => {
  return fetch.get(`/v1/contact_way/stores/${params.storeId}`, {
    params: {
      channel: params.channel,
      name: params.name,
      storeId: params.storeId
    }
  })
}

export default {
  getDetail
}
